import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpcomingTaxDeadlineAlertCibc = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 112 112",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:#f2f3f3;}.b{fill:#812a42;}.c,.e{fill:#c51f3f;}.c,.f{fill-rule:evenodd;}.d,.f{fill:#fff;}" }) }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 50,
			cy: 50,
			r: 50
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M52.6,25.51V40.28a1.09,1.09,0,0,0,1.12,1.12H68.49Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "c",
			d: "M64.26,51.22H66V50.1H38v1.12ZM66,57.45H38V56.33H66Zm-1.76,6.23H66v-1H38v1ZM53.72,42.52H69.13a1.22,1.22,0,0,1,1.2,1.12v30.1H33.83v-50H50.36a1.09,1.09,0,0,1,1.12,1.12V40.36A2.22,2.22,0,0,0,53.72,42.52Z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "d",
			points: "66.02 51.22 64.34 51.22 37.98 51.22 37.98 50.1 66.02 50.1 66.02 51.22"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "d",
			points: "66.02 57.45 64.34 57.45 37.98 57.45 37.98 56.41 66.02 56.41 66.02 57.45"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "d",
			points: "66.02 63.68 64.34 63.68 37.98 63.68 37.98 62.64 66.02 62.64 66.02 63.68"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "e",
			cx: 33.83,
			cy: 36.93,
			r: 8.31
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "d",
			d: "M33.83,29.11A7.82,7.82,0,1,1,26,36.93a7.82,7.82,0,0,1,7.81-7.82m0-1a8.82,8.82,0,1,0,8.81,8.82,8.83,8.83,0,0,0-8.81-8.82Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "f",
			d: "M31.1,35a.38.38,0,0,0,.39.39c.29,0,.78-.24.78-.39s-.49-.39-.78-.39A.39.39,0,0,0,31.1,35Zm3.51-.39A.39.39,0,0,1,35,35a.38.38,0,0,1-.39.39c-.29,0-.78-.24-.78-.39S34.32,34.58,34.61,34.58Zm2.2,2.36-3-.75v-.68a1.58,1.58,0,0,0,.78.24.78.78,0,0,0,0-1.56,1.82,1.82,0,0,0-.78.24V33.8a.78.78,0,1,0-1.56,0v.63a1.82,1.82,0,0,0-.78-.24.79.79,0,0,0-.68.39.78.78,0,0,0,0,.78.77.77,0,0,0,.68.39,1.58,1.58,0,0,0,.78-.24v2L31.53,37a.53.53,0,0,0-.75.71l1.51,3a.19.19,0,0,0,.17.1h3.91a.19.19,0,0,0,.19-.17l.4-3.5A.22.22,0,0,0,36.81,36.94Z"
		})
	]
});
const ForwardRef = forwardRef(SvgUpcomingTaxDeadlineAlertCibc);
export { ForwardRef as ReactComponent };
